import React from 'react'
import './Partner.css'
import microsoft from './../../Assets/partners/microsoft.png'
import allianz from './../../Assets/partners/allianz.png'
import upwork from './../../Assets/partners/upwork.png'
import volvo from './../../Assets/partners/volvo.png'
import grab from './../../Assets/partners/grab.png'
import verizon from './../../Assets/partners/verizon.png'
import coinbase from './../../Assets/partners/coinbase.png'
import expedia from './../../Assets/partners/expedia.png'
import airtable from './../../Assets/partners/airtable.png'
import magneto from './../../Assets/partners/magneto.png'
import carrera from './../../Assets/partners/carrera.png'
import bonanza from './../../Assets/partners/bonanza.png'
import wetransfer from './../../Assets/partners/wetransfer.png'
import suzuki from './../../Assets/partners/suzuki.png'
import algolia from './../../Assets/partners/algolia.png'
import heineken from './../../Assets/partners/heineken.png'


function Partner() {

    const observer = new IntersectionObserver((enteries) => {
        enteries.forEach((entry) => {
          console.log(entry);
          if(entry.isIntersecting){
            entry.target.classList.add('show1');
          }
        })
      })
    
      setTimeout(() => {
      const hiddenElements = document.querySelectorAll('.hidden1');
      hiddenElements.forEach((el) => observer.observe(el));
      });


    return (
        <div className='hidden1'>
        <div id='partner_lan'>
            <h1>SheildScan make +1000 Startup secure</h1>
            <div className='partner_section_container'>
                <div className='partner_section_box'>
                    <img src={microsoft} />
                    <img src={allianz} />
                    <img src={upwork} />
                    <img src={volvo} />
                </div>
                <div className='partner_section_box'>
                    <img src={grab} />
                    <img src={verizon} />
                    <img src={coinbase} />
                    <img src={expedia} />
                </div>
                <div className='partner_section_box'>
                    <img src={airtable} />
                    <img src={magneto} />
                    <img src={carrera} />
                    <img src={bonanza} />
                </div>
                <div className='partner_section_box'>
                    <img src={wetransfer} />
                    <img src={suzuki} />
                    <img src={algolia} />
                    <img src={heineken} />
                </div>
            </div>
        </div>
        </div>
    )
}

export default Partner
